function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable max-len */
import { DocType } from "./constant/doc-type";
import { archiveMimeTypes, AudioMimeTypes, CodeMimeTypes, ExcelMimeTypes, ImageMimeTypes, PowerPointMimeTypes, TextMimeTypes, VideoMimeTypes, WordMimeTypes } from "./constant/enumerate";
import { audio, code, doc, image, novel, ppt, text, video, xls, zip } from "./constant/ext";
import { extToMimeTypeMap } from "./constant/ext-to-mimetype";
import { MimeType } from "./constant/mime-type";
import { PadType } from "./constant/pad-type";
import { Classify, docTypeToMimeTypeMap, drivePadTypeToMimeTypeMap, mimeTypeToDocTypeMap, mimeTypeToPadType, padTypeToDocTypeMap, padTypeToMimeTypeMap } from "./constant/types";
import { isSpecifyLike } from "./util";
/**
 * 是否为小说
 */
export var isNovelLike = function isNovelLike(type) {
  return isSpecifyLike(novel)(type);
};

/**
 * 是否为本地 office Word 包括金山文档
 */
export var isWordLike = function isWordLike(type) {
  return WordMimeTypes.includes(type) || isSpecifyLike(doc)(type);
};

/**
 * 是否为本地 office Excel 包括金山文档
 */
export var isExcelLike = function isExcelLike(type) {
  return ExcelMimeTypes.includes(type) || isSpecifyLike(xls)(type);
};

/**
 * 是否为本地 office PowerPoint 包括金山文档
 */
export var isPowerPointLike = function isPowerPointLike(type) {
  return PowerPointMimeTypes.includes(type) || isSpecifyLike(ppt)(type);
};

/**
 * 是否为纯文本
 */
export var isTextLike = function isTextLike(type) {
  return TextMimeTypes.includes(type) || isSpecifyLike(text)(type);
};

/**
 * 是否为代码文件
 */
export var isCodeLike = function isCodeLike(type) {
  return CodeMimeTypes.includes(type) || isSpecifyLike(code)(type);
};

/**
 * 是否为图片文件
 */
export var isImageLike = function isImageLike(type) {
  return ImageMimeTypes.includes(type) || isSpecifyLike(image)(type);
};

/**
 * 是否为音频文件
 */
export var isAudioLike = function isAudioLike(type) {
  return AudioMimeTypes.includes(type) || isSpecifyLike(audio)(type);
};

/**
 * 是否为音频文件
 */
export var isVideoLike = function isVideoLike(type) {
  return VideoMimeTypes.includes(type) || isSpecifyLike(video)(type);
};

/**
 * 是否为压缩包文件
 */
export var isZipLike = function isZipLike(type) {
  return archiveMimeTypes.includes(type) || isSpecifyLike(zip)(type);
};

/**
 * (.doc | .dot）微软 Office Word 格式（Microsoft Word 97 - 2004 document）
 */
export var isDOC = function isDOC(type) {
  return type === 'application/msword' || isSpecifyLike(['doc', 'dot'])(type);
};

/**
 * (.docx) 微软 Office Word 文档格式
 */
export var isDOCX = function isDOCX(type) {
  return type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || isSpecifyLike(['docx'])(type);
};

/**
 * (.xls .xlm .xla .xlc .xlt .xlw) 微软 Office Excel 格式（Microsoft Excel 97 - 2004 Workbook
 */
export var isXLS = function isXLS(type) {
  return type === 'application/vnd.ms-excel' || isSpecifyLike(['xls', 'xlm', 'xla', 'xlc', 'xlw'])(type);
};

/**
 * (.xlsx) 微软 Office Excel 文档格式
 */
export var isXLSX = function isXLSX(type) {
  return type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || isSpecifyLike(['xlsx'])(type);
};

/**
 * (.ppt .pps .pot) 微软 Office PowerPoint 格式（Microsoft PowerPoint 97 - 2003 演示文稿
 */
export var isPPT = function isPPT(type) {
  return type === 'application/vnd.ms-powerpoint' || isSpecifyLike(['ppt', 'pps', 'pot'])(type);
};

/**
 * (.pptx) 微软 Office PowerPoint 文稿格式
 */
export var isPPTX = function isPPTX(type) {
  return type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || isSpecifyLike(['pptx'])(type);
};

/**
 * 是否是在线文档.
 */
export var isOnlineDoc = function isOnlineDoc(mimeType) {
  return /^application\/vnd\.tdocs-apps/i.test(mimeType);
};

/**
 * (addon) 插件类型
 */
export var isAddon = function isAddon(mimeType) {
  return /^application\/vnd\.tdocs-addon/i.test(mimeType);
};

/**
 * 是否是在线文档的 Markdown 品类
 */
export var isMarkdown = function isMarkdown(type) {
  return type === MimeType.Markdown || type === PadType.Markdown || type === DocType.Markdown;
};

/**
 * 通过后缀来推导出来MimeType
 */
export var getMimeTypeFromExt = function getMimeTypeFromExt(ext) {
  if (extToMimeTypeMap[ext]) {
    return extToMimeTypeMap[ext];
  }
  console.warn('unknown extension');
  return 'unknown';
};

/**
 *  drive 和 folder的 不适用，因为drive需要后缀才能判断。folder需要CollaborationFlag
 */
export var getMimeTypeFromDocType = function getMimeTypeFromDocType(docType) {
  if (docTypeToMimeTypeMap[docType]) {
    return docTypeToMimeTypeMap[docType];
  }
  console.warn('unknown docType');
  return 'unknown';
};

/**
 *  @deprecated 为了兼容老附件写的一个方法，不建议使用
 */
export var getClassifyFromExt = function getClassifyFromExt(ext) {
  if (video.includes(ext)) return Classify.Video;
  if (audio.includes(ext)) return Classify.Audio;
  if (image.includes(ext)) return Classify.Image;
  if (doc.includes(ext)) return Classify.Doc;
  if (zip.includes(ext)) return Classify.Zip;
  return Classify.Unknown;
};
export var getDocTypeFromMimeType = function getDocTypeFromMimeType(mimeType) {
  var _iterator = _createForOfIteratorHelper(mimeTypeToDocTypeMap),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        mimeTypeItem = _step$value[0],
        docType = _step$value[1];
      if (mimeTypeItem.includes(mimeType)) {
        return docType;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return;
};

/*
 * isDrive = true , padType = slide  => mimeType: 'application/vnd.ms-powerpoint'
 * isDrive = false, padType = slide  => mimeType: 'application/vnd.tdocs-apps.slide'
 */
export var getMimeTypeFromPadType = function getMimeTypeFromPadType(padType) {
  var isDrive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isDrive) {
    return drivePadTypeToMimeTypeMap[padType] || 'unknown';
  }
  return padTypeToMimeTypeMap[padType] || 'unknown';
};
export var getPadTypeFromMimeType = function getPadTypeFromMimeType(mimeType) {
  var _iterator2 = _createForOfIteratorHelper(mimeTypeToPadType),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        mimeTypeItem = _step2$value[0],
        padType = _step2$value[1];
      if (mimeTypeItem.includes(mimeType)) {
        return padType;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return PadType.Drive;
};
export var getDocTypeFromPadType = function getDocTypeFromPadType(padType) {
  var docType = padTypeToDocTypeMap[padType];
  if (docType) {
    return docType;
  }
  console.warn('unknown padType');
  return DocType.Unknown;
};

/**
 * 是否是在线文档的doc品类
 */
export var isDoc = function isDoc(type) {
  return type === MimeType.Doc || type === PadType.Doc || type === DocType.Doc;
};

/**
 * 是否是在线文档的sheet品类
 */
export var isSheet = function isSheet(type) {
  return type === MimeType.Sheet || type === PadType.Sheet || type === DocType.Sheet;
};

/**
 * 是否是在线文档的slide品类
 */
export var isSlide = function isSlide(type) {
  return type === MimeType.Slide || type === PadType.Slide || type === DocType.Slide;
};

/**
 * 是否是在线文档的Form品类
 */
export var isForm = function isForm(type) {
  return type === MimeType.Form || type === PadType.Form || type === DocType.Form;
};

/**
 * 是否是在线文档的SmartSheet品类
 */
export var isSmartSheet = function isSmartSheet(type) {
  return type === MimeType.SmartSheet || type === PadType.SmartSheet || type === DocType.SmartSheet;
};

/**
 * 是否是在线文档的SmartCanvas品类
 */
export var isSmartCanvas = function isSmartCanvas(type) {
  return type === MimeType.SmartCanvas || type === PadType.SmartCanvas || type === DocType.SmartCanvas;
};

/**
 * 是否是在线文档的Mind品类
 */
export var isMind = function isMind(type) {
  return type === MimeType.Mind || type === PadType.Mind || type === DocType.Mind;
};

/**
 * 是否是在线文档的Mind品类
 */
export var isFlowChart = function isFlowChart(type) {
  return type === MimeType.FlowChart || type === PadType.FlowChart || type === DocType.FlowChart;
};
export var isPDF = function isPDF(type) {
  return type === MimeType.Pdf || type === PadType.Pdf || type === DocType.Pdf;
};

/**
 * 是否是在线文档的Board品类
 */
export var isBoard = function isBoard(type) {
  return type === MimeType.Board || type === PadType.Board || type === DocType.Board;
};

/**
 * 判断是否是Microsoft类的Office文件
 * 包含 word, excel, powerpoint
 */
export var isMicrosoftFile = function isMicrosoftFile(type) {
  return isWordLike(type) || isExcelLike(type) || isPowerPointLike(type);
};

/**
 * Drive 类 Office文件 + PDF
 **/
export var isMicrosoftFileOrPDF = function isMicrosoftFileOrPDF(type) {
  return isMicrosoftFile(type) || isPDF(type);
};

/**
 * Drive 类 图、音、视频文件
 * type 可以是 mime-type 也可以是 string
 **/
export var isImgAudioOrVideo = function isImgAudioOrVideo(type) {
  return isImageLike(type) || isAudioLike(type) || isVideoLike(type) || audio.includes(type) || image.includes(type) || video.includes(type);
};

/**
 * @description 获取各品类上报名称
 * doc、sheet、slide、pdf、mind、form、flowchart、smartsheet、smartcanvas、board、pic、video、audio
 */
export var getCategoryForReport = function getCategoryForReport(ext) {
  if (isDoc(ext) || isWordLike(ext)) return 'doc';
  if (isSheet(ext) || isExcelLike(ext)) return 'sheet';
  if (isSlide(ext) || isPowerPointLike(ext)) return 'slide';
  if (isPDF(ext)) return 'pdf';
  if (isMind(ext)) return 'mind';
  if (isForm(ext)) return 'form';
  if (isFlowChart(ext)) return 'flowchart';
  if (isSmartSheet(ext)) return 'smartsheet';
  if (isSmartCanvas(ext)) return 'smartcanvas';
  if (isBoard(ext)) return 'board';
  if (isImageLike(ext)) return 'pic';
  if (isVideoLike(ext)) return 'video';
  if (isAudioLike(ext)) return 'audio';
  return ext;
};
//# sourceMappingURL=detect-methods.js.map